import React from "react";
import SoftwareCard from "./SoftwareCard";

const softwareData = [
  {
    name: "RioSat Smart IPTV",
    description: "Riosat Smart Iptv Cihazı Güncel Yazılımı",
    downloadUrl: "/files/2517.bin",
    imageUrl: "/files/smart iptv.jpeg", 
  },
  {
    name: "VMS",
    description: "Dijital Video Kayıt Cihazlarımız için VMS/CMS",
    downloadUrl: "/files/VMS.exe",
    imageUrl: "/files/vmsdvrlogo.jpeg", 
  },
  {
    name: "RHD 870 Mini HD FV İşlemci",
    description: "",
    downloadUrl: "/files/RIOSAT_RHD870_1506FV_512_4M_SCW1_61321_rls6_20250806_162422.bin",
    imageUrl: "/files/rhd870.jpeg", 
  },
  {name:"RHD 870 Çift USB Mini HD HV İşlemci",
   description:"",
   downloadUrl:"/files/CİFT USB HD ZETTA 25@32.bin",
   imageUrl:"/files/rhd870.jpeg" 
  },
  {name:"RHD 900 Kasalı HD FV İşlemci",
   description:"",
   downloadUrl:"/files/kasalı hd 2026 md 128.bin",
   imageUrl:"/files/rio-kasali.jpeg" 
  }
];

function SoftwareList() {
  return (
    <div className="row">
      {softwareData.map((software, index) => (
        <div className="col-md-4 mb-4" key={index}>
          <SoftwareCard software={software} />
        </div>
      ))}
    </div>
  );
}

export default SoftwareList;
